import { lazy } from 'react';

const MedicalInstitutions = [
  {
    path: 'medical-institutions',
    component: lazy(() => import('pages/medical-institutions')),
  },
];

export default MedicalInstitutions;
